import { PackingSupplierStatusEnum, PaymentTypes, SoStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { AsnItems } from "./asn-items.entity";

@Entity("asn")
export class Asn {
    @PrimaryGeneratedColumn("increment", { name: 'asn_id' })
    asnId: number;

    @Column({
        nullable: false,
        name: "asn_date"
    })
    asnDate: Date;

    @Column("varchar", {
        nullable: false,
        name: "asn_number"
    })
    asnNumber: string;

    @Column("varchar", {
        nullable: false,
        name: "shipment_no"
    })
    shipmentNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "invoice_no"
    })
    invoiceNumber: string;

    @Column({
        nullable: true,
        name: "invoice_date"
    })
    invoiceDate: Date;

    @Column("varchar",{
        nullable: true,
        name: "vehicle_no"
    })
    vehicleNo: string;

    @Column("varchar",{
        nullable: true,
        name: "driver_name"
    })
    driverName: string;

    @Column("varchar",{
        nullable: true,
        name: "driver_ph_no"
    })
    driverPhNo: string;

    @Column({
        nullable: true,
        name: "invoice_due_date"
    })
    invoiceDueDate: Date;

    @Column({
        type: 'enum',
        enum: PackingSupplierStatusEnum,
        nullable: false,
        name: 'asn_status',
        default: PackingSupplierStatusEnum.OPEN
    })
    asnStatus: PackingSupplierStatusEnum;

    @Column({
        type: 'enum',
        enum: PaymentTypes,
        nullable: true,
        name: 'payment_type',
        default: PaymentTypes.BANK_TRANSFER
    })
    paymentType: PaymentTypes;
    @Column({
        nullable: true,
        name: "payment_date"
    })
    paymentDate: Date;

    @Column("int", {
        nullable: true,
        name: "received_amount"
    })
    receivedAmount: number;



    @Column("varchar", {
        nullable: false,
        name: "eway_bill_no"
    })
    eWayBillNo: string;

    @Column("varchar", {
        nullable: false,
        name: "dc_number"
    })
    dcNumber: string;


    @Column("int", {
        nullable: false,
        name: "vendor_id"
    })
    vendorId: number;

    @Column("boolean", {
        nullable: true,
        name: "is_acknowledged"
    })
    isAcknowledged: boolean;

   
    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

   

    @OneToMany(type => AsnItems, asnItems => asnItems.asnInfo, { cascade: true })
    asnItemsInfo: AsnItems[];
    
    @Column("varchar",{
        name:"file_name",
       })
       fileName?:string;
    
       @Column("varchar",{
       name:"file_path"
       })
       filePath?:string;

}

